module.exports = __webpack_public_path__ + "img/calhoun-logo.04716b7c.jpg";